'use client'

import Image from 'next/image'
import React, { useState } from 'react'

export default function GalleryPosts({ listImage }: any) {
  const [indexCurrent, setIndexCurrent] = useState(0)
  const [currentImage, setCurrentImage] = useState('')
  const isOpen = currentImage != ''

  function handleClickOpenImage(index: number) {
    setIndexCurrent(index)
    setCurrentImage(listImage[index].attributes.url)
  }

  function handleCloseLightBox() {
    setCurrentImage('')
  }

  function handleNavigate(direction: 'next' | 'previous') {
    let index = direction === 'next' ? indexCurrent + 1 : indexCurrent - 1

    if (index < 0) {
      index = listImage.length - 1
    }

    if (index >= listImage.length) {
      index = 0
    }

    setIndexCurrent(index)
    setCurrentImage(listImage[index].attributes.url)
  }

  return (
    <>
      {listImage &&
        listImage.map((img: any, index: number) => (
          <div key={index} className="w-full">
            <Image
              src={img.attributes.url}
              alt="Image"
              width={500}
              height={300}
              className="cursor-pointer rounded-sm transition-all ease-linear hover:scale-110"
              onClick={() => handleClickOpenImage(index)}
            />
          </div>
        ))}

      {isOpen && (
        <div className="fixed inset-0 z-90 flex h-full w-full items-center justify-center gap-2 bg-black bg-opacity-70">
          <button
            className="absolute right-5 top-8 w-10"
            onClick={handleCloseLightBox}
          >
            <Image
              src="/assets/img/close.svg"
              alt="Button Close"
              width={400}
              height={400}
            />
          </button>
          <button
            className="hidden w-12 rotate-180 transition-opacity ease-linear hover:opacity-50 md:block"
            onClick={() => handleNavigate('previous')}
          >
            <Image
              src="/assets/img/arrow.svg"
              alt="Arrow Previous"
              width={400}
              height={400}
            />
          </button>
          {currentImage && (
            <>
              <Image
                src={currentImage}
                alt="Infra Image"
                width={700}
                height={400}
                className="w-fit px-4"
              />
              <div className="absolute bottom-14 md:hidden">
                <button
                  className="w-12 rotate-180 transition-opacity ease-linear hover:opacity-50 md:hidden"
                  onClick={() => handleNavigate('previous')}
                >
                  <Image
                    src="/assets/img/arrow.svg"
                    alt="Arrow Previous"
                    width={400}
                    height={400}
                  />
                </button>
                <button
                  className="w-12 transition-opacity ease-linear hover:opacity-50 md:hidden"
                  onClick={() => handleNavigate('next')}
                >
                  <Image
                    src="/assets/img/arrow.svg"
                    alt="Arrow Next"
                    width={400}
                    height={400}
                  />
                </button>
              </div>
            </>
          )}
          <button
            className="hidden w-12 transition-opacity ease-linear hover:opacity-50 md:block"
            onClick={() => handleNavigate('next')}
          >
            <Image
              src="/assets/img/arrow.svg"
              alt="Arrow Next"
              width={400}
              height={400}
            />
          </button>
        </div>
      )}
    </>
  )
}
